import { Base, importWhenVisible } from '@studiometa/js-toolkit';
import 'liquid-ajax-cart';
import Figure from './Figure.js';
import Navbar from './Navbar/index.js';
import Header from './Header/index.js';
import Cart from './Cart/index.js';
import Blog from './Blog/index.js';
import LanguageModal from './LanguageModal.js';
import LanguageSelectModal from './LanguageSelectModal.js';
import Panel from './Panel.js';
import ScrollingAttributes from './ScrollingAttributes.js';
import Product from './Product/index.js';

/**
 * Shop component
 */
export default class Shop extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Shop',
    components: {
      Figure,
      Header,
      Navbar,
      Cart,
      Blog,
      Panel,
      Product,
      ScrollingAttributes,
      Readmore: (app) => importWhenVisible(() => import('./Readmore.js'), 'Readmore', app),
      Facets: (app) => importWhenVisible(() => import('./Facets/index.js'), 'Facets', app),
      VariantMedia: (app) =>
        importWhenVisible(() => import('./VariantMedia.js'), 'VariantMedia', app),
      LanguageModal,
      LanguageSelectModal,
      AccessibilityWidget: (app) =>
        importWhenVisible(() => import('./AccessibilityWidget.js'), 'AccessibilityWidget', app),
      ObfuscatedLink: (app) =>
        importWhenVisible(() => import('./ObfuscatedLink.js'), 'ObfuscatedLink', app),
    },
  };
}
